/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiTemplateField } from './BridgeApiTemplateField';
import {
    BridgeApiTemplateFieldFromJSON,
    BridgeApiTemplateFieldFromJSONTyped,
    BridgeApiTemplateFieldToJSON,
    BridgeApiTemplateFieldToJSONTyped,
} from './BridgeApiTemplateField';

/**
 * Requested fields
 * @export
 * @interface InternalApiAlertRfiRequestedFields
 */
export interface InternalApiAlertRfiRequestedFields {
    /**
     * List of field names that are part of the template
     * @type {Array<string>}
     * @memberof InternalApiAlertRfiRequestedFields
     */
    fromTemplate: Array<string>;
    /**
     * List of fully described fields that were not part of the template
     * @type {Array<BridgeApiTemplateField>}
     * @memberof InternalApiAlertRfiRequestedFields
     */
    custom: Array<BridgeApiTemplateField>;
}

/**
 * Check if a given object implements the InternalApiAlertRfiRequestedFields interface.
 */
export function instanceOfInternalApiAlertRfiRequestedFields(value: object): value is InternalApiAlertRfiRequestedFields {
    if (!('fromTemplate' in value) || value['fromTemplate'] === undefined) return false;
    if (!('custom' in value) || value['custom'] === undefined) return false;
    return true;
}

export function InternalApiAlertRfiRequestedFieldsFromJSON(json: any): InternalApiAlertRfiRequestedFields {
    return InternalApiAlertRfiRequestedFieldsFromJSONTyped(json, false);
}

export function InternalApiAlertRfiRequestedFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertRfiRequestedFields {
    if (json == null) {
        return json;
    }
    return {
        
        'fromTemplate': json['fromTemplate'],
        'custom': ((json['custom'] as Array<any>).map(BridgeApiTemplateFieldFromJSON)),
    };
}

export function InternalApiAlertRfiRequestedFieldsToJSON(json: any): InternalApiAlertRfiRequestedFields {
    return InternalApiAlertRfiRequestedFieldsToJSONTyped(json, false);
}

export function InternalApiAlertRfiRequestedFieldsToJSONTyped(value?: InternalApiAlertRfiRequestedFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromTemplate': value['fromTemplate'],
        'custom': ((value['custom'] as Array<any>).map(BridgeApiTemplateFieldToJSON)),
    };
}

